import { render } from "./PriceSelection.vue?vue&type=template&id=1f61ad7f&ts=true"
import script from "./PriceSelection.vue?vue&type=script&lang=ts"
export * from "./PriceSelection.vue?vue&type=script&lang=ts"

import "./PriceSelection.vue?vue&type=style&index=0&id=1f61ad7f&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__